import { createFileRoute } from '@tanstack/react-router';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { useHasEverPairedDeviceSuspense } from 'src/api/queries';
import { OneTimeCode } from 'src/apps/device/components';

import { CardContent, Sheet } from 'src/components';

export const Route = createFileRoute('/_auth/pair/app')({
  component: () => <PairComponent />,
});

const PairComponent = () => {
  const hasEverPairedDevice = useHasEverPairedDeviceSuspense();

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center py-64">
      <Sheet>
        <CardContent>
          <OneTimeCode
            hideBack
            showUserInfo
            showLogout
            successRedirectUrl={undefined}
            description="Enter this one-time code in the app to pair it with your reMarkable and sync your notes."
            allowPairing={hasEverPairedDevice.data}
            deviceTypeString="app"
            componentLocation={ComponentLocations.PAIR.APP}
          />
        </CardContent>
      </Sheet>
    </div>
  );
};
